import { downloadDocUri } from "data/api";
import { toastActionResult } from "data/toast";

/**
 * starts a download for the given itemUri
 *
 * @param {{ itemUri: string }} { itemUri }
 */

type Context = {
    itemUri: string,
};

class doc_download {
    queueMultiple: boolean = true;
    logger: () => any = toastActionResult;
    execute = async ({ itemUri }: Context): Promise<boolean> => {
        try {
            const uri = await downloadDocUri(itemUri);
            if (uri == null)
                throw new Error("Error while creating Download URI (empty)");

            // HACK: to download multiple files
            const temporaryDownloadLink = document.createElement("a");
            temporaryDownloadLink.style.display = "none";
            temporaryDownloadLink.setAttribute("href", uri);
            temporaryDownloadLink.setAttribute("download", true);
            document.body.appendChild(temporaryDownloadLink);
            temporaryDownloadLink.click();
            document.body.removeChild(temporaryDownloadLink);

            return true;
        } catch (err) {
            return false;
        }
    };
    report = async (success: boolean): Promise<boolean> => {
        !success && this.logger(success, "commandAction:doc_download");
    };
}
export default doc_download;
